<template>
	<td
		v-if="actions != null && Array.isArray(actions) == true"
		class="text-right"
	>
		<button
			v-for="(btn, index) in customButons"
			:key="index"
			v-if="btn.emit != undefined && enable(btn.if, row)"
			@click="$emit('customAction', { data: row, action: btn.emit })"
			class="btn btn-xs"
			:class="btn.color"
		>
			<i v-if="btn.icon != undefined" class="fa" :class="btn.icon"></i>
			<span v-if="btn.text != undefined">{{ btn.text }}</span>
		</button>

		<button
			v-if="enable('edit')"
			@click="$emit('customAction', { data: row, action: 'edit' })"
			class="btn btn-primary btn-xs"
		>
			<i class="fa fa-edit"></i>
		</button>
		<button
			v-if="enable('delete')"
			@click="$emit('customAction', { data: row, action: 'delete' })"
			class="btn btn-danger btn-xs"
		>
			<i class="fa fa-trash"></i>
		</button>
	</td>
	<td v-else-if="actions != null && Array.isArray(actions) == false">
		<component :is="actions"></component>
	</td>
</template>
<script>
	export default {
		props: ['actions', 'row'],
		provide() {
			const row = {};
			for (let col in this.row) {
				Object.defineProperty(row, col, {
					enumerable: true,
					get: () => this.row[col],
				});
			}
			return { row };
		},
		computed: {
			customButons() {
				if (
					this.actions == null ||
					Array.isArray(this.actions) == false
				)
					return [];
				else
					return this.actions.filter(
						(item) => typeof item != 'string'
					);
			},
		},
		methods: {
			enable(btn, row = null) {
				if (btn == undefined) return true;
				if (typeof btn == 'string') {
					if (Array.isArray(this.actions) == false) return false;
					let index = this.actions.findIndex((item) => item == btn);
					return index != -1;
				} else {
					try {
						return btn(row);
					} catch (e) {
						return false;
					}
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/app-components/table/actions.vue